import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface NavItem {
  name: string;
  path: string;
  icon: string;
}

const menuItems: NavItem[] = [
  { name: 'Khám phá', path: '/business-marketplace', icon: 'storefront' },
  { name: 'Đăng bán', path: '/business-marketplace/sell', icon: 'add_box' },
  { name: 'Của tôi', path: '/business-marketplace/my-listings', icon: 'inventory_2' },
  { name: 'Giao dịch', path: '/business-marketplace/trades', icon: 'swap_horiz' },
  { name: 'Rút tiền', path: '/business-marketplace/withdrawals', icon: 'account_balance_wallet' },
];

const PRIMARY = '#6C63FF';
const PRIMARY_RGB = '108, 99, 255';

const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside
      style={{
        width: '80px',
        backgroundColor: 'var(--color-bg-card)',
        borderRight: '1px solid var(--color-border)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '24px',
        paddingBottom: '24px',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 20,
        boxShadow: 'var(--shadow-soft)',
      }}
    >
      {/* Logo */}
      <div
        style={{
          marginBottom: '32px',
          padding: '10px',
          background: `rgba(${PRIMARY_RGB}, 0.1)`,
          borderRadius: '12px',
        }}
      >
        <span
          className="material-symbols-outlined"
          style={{ color: PRIMARY, fontSize: '28px' }}
        >
          storefront
        </span>
      </div>

      {/* Nav */}
      <nav
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%',
          padding: '0 12px',
        }}
      >
        {menuItems.map((item) => {
          const isActive = item.path === '/business-marketplace'
            ? location.pathname === item.path
            : location.pathname.startsWith(item.path);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/business-marketplace'}
              style={{ position: 'relative', display: 'flex', justifyContent: 'center', textDecoration: 'none' }}
            >
              {() => (
                <>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '48px',
                      height: '48px',
                      borderRadius: '12px',
                      backgroundColor: isActive ? `rgba(${PRIMARY_RGB}, 0.12)` : 'transparent',
                      color: isActive ? PRIMARY : 'var(--color-text-secondary)',
                      transition: 'all 0.2s ease',
                      cursor: 'pointer',
                    }}
                    className="sidebar-icon-btn"
                  >
                    <span className="material-symbols-outlined" style={{ fontSize: '22px' }}>
                      {item.icon}
                    </span>
                  </div>
                  <div
                    className="sidebar-tooltip"
                    style={{
                      position: 'absolute',
                      left: 'calc(100% + 8px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: '#1F2937',
                      color: 'white',
                      fontSize: '12px',
                      padding: '4px 10px',
                      borderRadius: '6px',
                      whiteSpace: 'nowrap',
                      pointerEvents: 'none',
                      opacity: 0,
                      transition: 'opacity 0.15s ease',
                      zIndex: 50,
                    }}
                  >
                    {item.name}
                  </div>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
